<template>
    <v-app style="background-color: #f3f6f9">
        <v-main>

            <ServiceRequestsComp v-if="isAdmin" />

        </v-main>
    </v-app>
</template>
<script>
import Auth from '@/services/auth.service.js'
import ServiceRequestsComp from '@/components/admin/serviceRequests/ServiceRequestsComp.vue'

export default {
    components: {
        ServiceRequestsComp,
    },
    data() {
        return {
            isAdmin: false,
        };
    },
    methods: {
    },
    computed: {
    },
    mounted() {
        document.title = 'קריאות שירות | סים לחומרא'
        let auth = Auth.checkAuth();
        if (!auth) {
            return this.$router.replace({ name: "login" })
        }
        // קריאות שירות פתוחות ל-admin בלבד
        if (Auth.getUserRole() !== 'admin') {
            return this.$router.replace({ name: "home" })   // ← התאם לשם הראוט אצלך
        }
        this.isAdmin = true;
    },
}
</script>
<style>
</style>